module.exports = __webpack_public_path__ + "05ba5b31b7ce6d92f6eab1914999bbdb.svg";


//////////////////
// WEBPACK FOOTER
// ./Content/icons/sets/content-icons.svg
// module id = ./Content/icons/sets/content-icons.svg
// module chunks = 8